document.addEventListener('DOMContentLoaded', function() {

  var getX = function(e) {
    if (e.offsetX !== undefined) {
      return e.offsetX;
    } else if (e.layerX !== undefined) {
      return e.layerX;
    } else {
      var rect = e.target.getBoundingClientRect();
      var x = e.targetTouches[0].clientX - rect.left;
      return x;
    }
  };

  document.querySelectorAll('.rating').forEach(function(el) {
    var stars = el.querySelector('.empty-stars .stars');
    var form = el.querySelector('form');

    var updateStars = function(e) {
      var x = getX(e);

      if (x <= 20) {
        stars.style['width'] = '20%';
      } else if (x <= 40) {
        stars.style['width'] = '40%';
      } else if (x <= 60) {
        stars.style['width'] = '60%';
      } else if (x <= 80) {
        stars.style['width'] = '80%';
      } else {
        stars.style['width'] = '100%';
      }
    };

    var recoverStars = function() {
      var rating = stars.getAttribute('data-rating');
      stars.style['width'] = rating + '%';
    };

    var rate = function(e) {
      var x = getX(e);
      var score = form.querySelector('#rating_score');

      if (x <= 20) {
        score.value = 20;
      } else if (x <= 40) {
        score.value = 40;
      } else if (x <= 60) {
        score.value = 60;
      } else if (x <= 80) {
        score.value = 80;
      } else {
        score.value = 100;
      }

      var event = document.createEvent('HTMLEvents');
      event.initEvent('submit', true, true);
      form.dispatchEvent(event);
    };

    el.addEventListener('mouseover', updateStars);
    el.addEventListener('mousemove', updateStars);
    el.addEventListener('mouseout', recoverStars);
    el.addEventListener('mouseup', rate);

    el.addEventListener('touchstart', updateStars, { passive: true });
    el.addEventListener('touchmove', updateStars, { passive: true });
    el.addEventListener('touchcancel', recoverStars, { passive: true });
    el.addEventListener('touchend', rate, { passive: true });
  });

});
